import {
  locationIdFormat,
  productConversionSessionIdFormat,
  productConversionSessionLineIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const createProductConversionSession = {
  name: "createProductConversionSession" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({ sessionId: productConversionSessionIdFormat.schema }),
};

const binAllocationSchema = z.object({
  binName: z.string(),
  quantity: z.number().int().positive(),
});

export const addProductConversionLine = {
  name: "addProductConversionLine" as const,
  input: z.object({
    sessionId: productConversionSessionIdFormat.schema,
    sourceProductId: productIdFormat.schema,
    sourceBins: z.array(binAllocationSchema),
    targetProductId: productIdFormat.schema,
    targetBins: z.array(binAllocationSchema),
  }),
  output: z.object({ lineId: productConversionSessionLineIdFormat.schema }),
};

export const generateProductConversionBarcodeLabels = {
  name: "generateProductConversionBarcodeLabels" as const,
  input: z.object({
    productIds: z.array(productIdFormat.schema),
    quantities: z.array(z.number().int().positive()),
    printerId: z.number().optional(),
  }),
  output: z.object({
    pdfBase64: z.string(),
    printJobId: z.number().optional(),
  }),
};
